module.exports = __webpack_public_path__ + "static/media/14b.ef3eb53a.svg";